import React, { useState } from 'react';
import {
  VStack,
  Box,
  Button,
  Collapse,
  Text,
  useDisclosure,
  IconButton,
  Skeleton,
  SkeletonText,
} from '@chakra-ui/react';
import { FaChevronDown, FaChevronUp, FaInfoCircle } from 'react-icons/fa';
import AudioPlayer from './AudioPlayer';

const getCleanDescription = (html) => {
  // Get content between first <p> tags
  const firstParagraph = html.match(/<p>(.*?)<\/p>/)?.[1] || '';
  
  // Remove any remaining HTML tags
  const withoutTags = firstParagraph.replace(/<[^>]*>/g, '');
  
  // Clean up HTML entities
  return withoutTags
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\n/g, ' ')
    .trim();
};

const getCleanTitle = (title) => {
  // Remove series name from title (everything after | including the |)
  return title.split('|')[0].trim();
};

const EpisodeCard = ({ episode, duration, isLoading = false }) => {
  const { isOpen, onToggle } = useDisclosure();
  const cleanDescription = getCleanDescription(episode?.description || '');
  const cleanTitle = getCleanTitle(episode?.title || '');

  if (isLoading) {
    return (
      <VStack spacing={2} align="stretch">
        <Skeleton height="100px" mb={4} />
        <SkeletonText noOfLines={2} spacing={4} />
      </VStack>
    );
  }

  return (
    <VStack spacing={{ base: 2, sm: 3 }} align="stretch">
      <AudioPlayer
        id={episode.id}
        title={cleanTitle}
        audioUrl={episode.enclosure.url}
        imageUrl={episode.image}
        duration={duration}
        pubDate={episode.pubDate}
      />
      
      {cleanDescription && (
        <>
          <Button
            size={{ base: "xs", sm: "sm" }}
            variant="ghost"
            colorScheme="whiteAlpha"
            width="full"
            onClick={onToggle}
            leftIcon={<FaInfoCircle />}
            rightIcon={isOpen ? <FaChevronUp /> : <FaChevronDown />}
            _hover={{
              bg: 'rgba(255,255,255,0.06)'
            }}
          >
            Episode Details
          </Button>

          <Collapse in={isOpen} animateOpacity>
            <Box position="relative" overflow="hidden" borderRadius="md">
              <Box position="absolute" top={0} left={0} right={0} h="2px" bgGradient="linear(to-r, transparent, brand.500, transparent)" zIndex={1} />
            <Text
              fontSize={{ base: "xs", sm: "sm" }}
              color="whiteAlpha.800"
              lineHeight="tall"
              background="rgba(255,150,50,0.04)"
              backdropFilter="blur(12px)"
              p={{ base: 3, sm: 4 }}
              borderRadius="md"
              border="1px solid rgba(255,150,50,0.08)"
            >
              {cleanDescription}
            </Text>
            </Box>
          </Collapse>
        </>
      )}
    </VStack>
  );
};

export default EpisodeCard;
